import { render, staticRenderFns } from "./markInfo.vue?vue&type=template&id=a9fd3822&scoped=true"
import script from "./markInfo.vue?vue&type=script&lang=js"
export * from "./markInfo.vue?vue&type=script&lang=js"
import style0 from "./markInfo.vue?vue&type=style&index=0&id=a9fd3822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fd3822",
  null
  
)

export default component.exports